import i18n from 'modules/core/lib/i18n'

export interface OptionInterface {
  value: string
  label: string
}

/*
 * This function is used to map the industry value from the server to the correct value in the frontend
 *
 * We need this map because some time ago we changed the list of the company industries and in that change
 * we removed some and add new ones, the problem is that in the database there was companies with the old
 * industries, so we need to map them to the new ones.
 */
export const mapIndutry = (value: string) => {
  return previousOptions(value) || value
}

const previousOptions = (value: string) => {
  switch (value) {
    case 'accommodation_food':
      return 'hospitality'
    case 'activities_extraterritorial':
      return 'other'
    case 'activities_households':
      return 'other'
    case 'administrative_support':
      return 'commercial_services'
    case 'arts_entertainment':
      return 'media_entertainment'
    case 'construction':
      return 'construction_engineering'
    case 'electricity_gas':
      return 'energy'
    case 'financial_insurance':
      return 'banking_insurance'
    case 'health_social_work':
      return 'healt_care_equipment_services'
    case 'information_communication':
      return 'telecommunication'
    case 'mining':
      return 'metals_mining'
    case 'other_services':
      return 'commercial_services'
    case 'professional_scientific':
      return 'other'
    case 'public_administration':
      return 'government_administration'
    case 'water_supply':
      return 'utilities'
    case 'wholesale_retail':
      return 'retailing'
    default:
      return null
  }
}

export const industryOptions = (): OptionInterface[] => {
  return [
    {
      value: 'aerospace_defense',
      label: i18n.t('company_industries.aerospace_defense'),
    },
    {
      value: 'agriculture',
      label: i18n.t('company_industries.agriculture'),
    },
    {
      value: 'automobiles_components',
      label: i18n.t('company_industries.automobiles_components'),
    },
    {
      value: 'banking_insurance',
      label: i18n.t('company_industries.banking_insurance'),
    },
    {
      value: 'chemicals',
      label: i18n.t('company_industries.chemicals'),
    },
    {
      value: 'commercial_services',
      label: i18n.t('company_industries.commercial_services'),
    },
    {
      value: 'metals_mining',
      label: i18n.t('company_industries.metals_mining'),
    },
    {
      value: 'commodities',
      label: i18n.t('company_industries.commodities'),
    },
    {
      value: 'construction_engineering',
      label: i18n.t('company_industries.construction_engineering'),
    },
    {
      value: 'consumer_durables_apparel',
      label: i18n.t('company_industries.consumer_durables_apparel'),
    },
    {
      value: 'consumer_services',
      label: i18n.t('company_industries.consumer_services'),
    },
    {
      value: 'containers_packaging',
      label: i18n.t('company_industries.containers_packaging'),
    },
    {
      value: 'diversified_financials',
      label: i18n.t('company_industries.diversified_financials'),
    },
    {
      value: 'energy',
      label: i18n.t('company_industries.energy'),
    },
    {
      value: 'food_staples_retailing',
      label: i18n.t('company_industries.food_staples_retailing'),
    },
    {
      value: 'food_beverage_tobacco',
      label: i18n.t('company_industries.food_beverage_tobacco'),
    },
    {
      value: 'education',
      label: i18n.t('company_industries.education'),
    },
    {
      value: 'government_administration',
      label: i18n.t('company_industries.government_administration'),
    },
    {
      value: 'healt_care_equipment_services',
      label: i18n.t('company_industries.healt_care_equipment_services'),
    },
    {
      value: 'hospitality',
      label: i18n.t('company_industries.hospitality'),
    },
    {
      value: 'internet_direct_marketing_retails',
      label: i18n.t('company_industries.internet_direct_marketing_retails'),
    },
    {
      value: 'legal_services',
      label: i18n.t('company_industries.legal_services'),
    },
    {
      value: 'machinery',
      label: i18n.t('company_industries.machinery'),
    },
    {
      value: 'manufacturing',
      label: i18n.t('company_industries.manufacturing'),
    },
    {
      value: 'media_entertainment',
      label: i18n.t('company_industries.media_entertainment'),
    },
    {
      value: 'military',
      label: i18n.t('company_industries.military'),
    },
    {
      value: 'non_profit_org',
      label: i18n.t('company_industries.non_profit_org'),
    },
    {
      value: 'other',
      label: i18n.t('company_industries.other'),
    },
    {
      value: 'pharmaceuticals_biotechnology',
      label: i18n.t('company_industries.pharmaceuticals_biotechnology'),
    },
    {
      value: 'real_estate',
      label: i18n.t('company_industries.real_estate'),
    },
    {
      value: 'research_consulting',
      label: i18n.t('company_industries.research_consulting'),
    },
    {
      value: 'retailing',
      label: i18n.t('company_industries.retailing'),
    },
    {
      value: 'semiconductors',
      label: i18n.t('company_industries.semiconductors'),
    },
    {
      value: 'software_it_services',
      label: i18n.t('company_industries.software_it_services'),
    },
    {
      value: 'tech_hardware_equipment',
      label: i18n.t('company_industries.tech_hardware_equipment'),
    },
    {
      value: 'telecommunication',
      label: i18n.t('company_industries.telecommunication'),
    },
    {
      value: 'trading_distributors',
      label: i18n.t('company_industries.trading_distributors'),
    },
    {
      value: 'transportation',
      label: i18n.t('company_industries.transportation'),
    },
    {
      value: 'utilities',
      label: i18n.t('company_industries.utilities'),
    },
    {
      value: 'travel_turism',
      label: i18n.t('company_industries.travel_turism'),
    },
  ]
}
